import JoggingTrackSvg from "@assets/images/svg/jogging-track.svg";
import React from "react";
import { View } from "react-native";

export interface JoggingTrackIconProps {
  size?: number;
  color?: string;
}

export function JoggingTrackIcon({
  size = 24,
  color = "#333333",
}: JoggingTrackIconProps) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <JoggingTrackSvg width={size} height={size} color={color} />
    </View>
  );
}

export default JoggingTrackIcon;
